export class Crop {

    constructor(public cropName: string) {
    }

}
